if (!window.customElements.get('custom-variant-static')) {
  window.customElements.define(
    'custom-variant-static',
    class CustomVariantStatic extends window.HTMLElement {
      connectedCallback() {
        this.initDOMElements();
        this.boundHandleChange = this.handleChange.bind(this);
        this.initEventListeners();
        this.handleChange();
      }

      disconnectedCallback() {
        this.removeEventListeners();
      }

      initDOMElements() {
        this.form = this.querySelector('form');
        this.deliveryInterval = this.querySelector('#current-option-name');
        this.addToCartButton = this.querySelector('#add-to-cart-button');
        this.addToCartSubscriptionPrice = this.querySelector('#add-to-cart-subscription-price');
        this.addToCartCompareAtPrice = this.querySelector('#add-to-cart-compare-at-price');
        this.buyOncePrice = this.querySelector('#buy-once-price');
        this.buyOnceButton = this.querySelector('#buy-once-button');
        this.enableGtmTracking = this.dataset.enableGtmTracking === 'true';
      }

      initEventListeners() {
        this.form?.addEventListener('change', this.boundHandleChange);
      }

      removeEventListeners() {
        this.form?.removeEventListener('change', this.boundHandleChange);
      }

      handleChange() {
        const currentVariantData = this.getCurrentVariantData();

        if (!currentVariantData) {
          return;
        }

        this.handleUpdateUI(currentVariantData);
      }

      handleUpdateUI(currentVariantData) {
        if (this.deliveryInterval) {
          this.deliveryInterval.textContent = currentVariantData.deliveryInterval;
        }

        if (this.addToCartButton) {
          this.addToCartButton.href = this.appendTrackingParams(currentVariantData.productUrl);
        }

        if (this.buyOnceButton) {
          this.buyOnceButton.href = this.appendTrackingParams(currentVariantData.buyOnceUrl);
        }

        if (this.addToCartSubscriptionPrice) {
          this.addToCartSubscriptionPrice.textContent = currentVariantData.price;
        }

        if (this.addToCartCompareAtPrice) {
          this.addToCartCompareAtPrice.textContent = currentVariantData.compareAtPrice;
        }

        if (this.buyOncePrice) {
          this.buyOncePrice.textContent = currentVariantData.buyOnePrice;
        }
      }

      getCurrentVariantData() {
        const currentVariant = this.form?.querySelector('input[type="radio"]:checked');

        if (!currentVariant) {
          return null;
        }

        const { deliveryInterval, compareAtPrice, price, savings, buyOnePrice, productUrl, buyOnceUrl } =
          currentVariant.dataset;

        return {
          deliveryInterval,
          price,
          compareAtPrice,
          buyOnePrice,
          savings,
          productUrl,
          buyOnceUrl,
        };
      }

      appendTrackingParams(url) {
        if (!this.enableGtmTracking || !url || !window.SeranovaTracking) {
          return url;
        }

        return window.SeranovaTracking.appendParams(url);
      }
    },
  );
}
